import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import { HighlightedCode } from '@mui/internal-core-docs/HighlightedCode';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/FormControl": FormControl, "@mui/material/FormLabel": FormLabel, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Grid": Grid, "@mui/material/Paper": Paper, "@mui/material/RadioGroup": RadioGroup, "@mui/material/Radio": Radio, "@mui/material/Stack": Stack, "@mui/internal-core-docs/HighlightedCode": { HighlightedCode } } } });
export default ClientProvider;
